const IDLE_TIME_TOOLTIP_CLICKED = 'Available People Idle Time Tooltip Clicked';

export {
  IDLE_TIME_TOOLTIP_CLICKED,
};
